import { render, staticRenderFns } from "./JoinUsCampus.vue?vue&type=template&id=98bd1622"
import script from "./JoinUsCampus.vue?vue&type=script&lang=js"
export * from "./JoinUsCampus.vue?vue&type=script&lang=js"
import style0 from "./JoinUsCampus.vue?vue&type=style&index=0&id=98bd1622&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports